module.exports = __webpack_public_path__ + "static/img/pm-persona.458a377.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pm-persona.png
// module id = 563
// module chunks = 1